import { useCallback } from 'react';

import { PERFORM_APPLICATION_ACTION } from '@applicant-flow/graphql';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';

export const useApplicationAction = ({
  refetchQueries = [],
}: {
  refetchQueries?: string[];
}) => {
  const applicationStatusErrorMessage = () =>
    createMessage(
      'error',
      'Failed to change application state. Please try again.'
    );

  const [performApplicationStateAction, { loading }] = useMutation(
    PERFORM_APPLICATION_ACTION,
    {
      refetchQueries,
      onCompleted: (data) => {
        if (data.performApplicationAction?.error) {
          applicationStatusErrorMessage();
          return;
        }

        createMessage('success', 'Application status successfully changed');
      },
      onError: applicationStatusErrorMessage,
    }
  );

  const shortlistForReview = useCallback(
    (applicationId?: string | null) => {
      if (!applicationId) return;

      performApplicationStateAction({
        variables: {
          staffingRequestApplicationId: applicationId,
          input: {
            action: 'review',
          },
        },
      });
    },
    [performApplicationStateAction]
  );

  return { loading, shortlistForReview };
};
